import { lazy, FC } from "react";
import {Routes, Route } from "react-router-dom";
import AddAgent from './views/agents/addAgent';
import "./index.css";
import "./custom.css";
// const AgentsList = Loadable(lazy(() => import('./views/agents/AgentList')));
// const AddAgent = Loadable(lazy(() => import('./views/agents/AddAgent')));
import AgentList from './views/agents/agentList';
import AddTool from "./views/canvas";
import Tool from "./views/tool";
import AddOrchestrator from './views/orchestrators/orchestrator'
import Orchestrator from "./views/orchestrators";
import UseAgents from "./views/agents/useAgents";
import UseTools from "./views/useTools";
import LoggedInHeaderLayout from "./layouts/LoggedInLayout";
import LoggedInNonHeaderLayout from "./layouts/NonHeaderLayout";
import ViewAgentDetail from "./views/agents/viewAgentDetail";
import Knowledge from "./views/knowledge";
import Integration from "./views/integration";
import DetailtsKnowledge from "./views/knowledge/detailsKnowledge";
import Login from "./views/Login";
import ProtectedRoute from "./route/protectedRoute";
// import ToolCreateModal from "./views/tools/Tools";
import NodeEditModal from "./views/tools/NodeEditModel";

// ============================== || APP || ============================== //
const App: FC = () => {
  return (
    <Routes>
      <Route path="/login" element={<Login />} /> 

      <Route element={<ProtectedRoute />}>
        <Route element={<LoggedInHeaderLayout />}>
          <Route index element={<AgentList />} />
          <Route path="/addagents/:slug" element={<AddAgent />} />
          <Route path="/tool" element={<Tool />} />
          <Route path="/orchestrator" element={<Orchestrator />} />
          <Route path="/knowledge" element={<Knowledge />} />
          <Route path="/knowledge/:id" element={<DetailtsKnowledge />} />
          <Route path="/integrations" element={<Integration />} />
          <Route path="/viewAgent/:id" element={<ViewAgentDetail />} />
        </Route>

        <Route element={<LoggedInNonHeaderLayout />}>
          <Route path="/useAgent/:id" element={<UseAgents />} />
          <Route path="/useTools/:id" element={<UseTools />} />
          <Route path="/orchestrator/add" element={<AddOrchestrator />} />
        </Route>

        <Route path="/addtool" element={<AddTool />} />
        <Route path="/addtool/:id" element={<AddTool />} />
        <Route path="/tool-edit" element={<NodeEditModal />} />
      </Route>

    </Routes>
  );
};
export default App;
